import { render, staticRenderFns } from "./AgencyChooseBeneficiaries.vue?vue&type=template&id=f434ceb2&"
import script from "./AgencyChooseBeneficiaries.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseBeneficiaries.vue?vue&type=script&lang=js&"
import style0 from "./AgencyChooseBeneficiaries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VFlex,VLayout,VSelect})
